import React from 'react'
import { Footer } from './Footer'
export const MainDiv=(props) =>{
return (
    <>
    <div id="content" class="app-content app-footer-fixed">
    <div className="row">
    
    {props.children}
    </div>
   
    </div>
    </>
  )
}
